import { useCallback } from 'react';

import { ValidationError } from '@bonusly/common-action-input';

import { useBonusBoxAnalytics } from './use-bonus-box-analytics';

export const useValidationError = () => {
	const analytics = useBonusBoxAnalytics();

	return useCallback(
		(errors: ValidationError[]) => {
			const reason = errors.map((error) => error.id).join(', ');

			analytics.trackSubmitFailure({ reason });
		},
		[analytics]
	);
};
